<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto dashboard-card" height="200" elevation="4">
      <template v-slot:progress>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="card-header">
        <v-icon class="mr-2" color="primary">mdi-calendar-check</v-icon>
        <div>
          <span class="text-h6 font-weight-medium">Aulas Lançadas</span>
          <div class="text-caption grey--text">Da Unidade Escolar</div>
        </div>
      </v-card-text>

      <v-row class="card-content" align="center" no-gutters>
        <v-col cols="7" class="pl-4">
          <v-card-text class="text-h3 font-weight-bold primary--text">
            {{ qtd ?? 0 }}
          </v-card-text>
          <v-card-text class="text-caption grey--text"> Total lançado </v-card-text>
        </v-col>

        <v-col cols="5" class="chart-container">
          <apexchart type="area" height="150" :options="chartOptions" :series="series"></apexchart>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    franquiaId: {
      type: Number,
    },
  },
  name: "AulasLancadas",
  mounted() {
    this.getQtd(this.franquiaId);
  },
  watch: {
    qtd() {
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: [...this.datas],
        },
      };
    },
    franquiaId(value) {
      this.loading = true;
      this.getQtd(value);
    },
  },
  data() {
    return {
      datas: [],
      qtd: 0,
      loading: true,
      series: [
        {
          name: "Aulas",
          data: [80, 88, 55, 888],
        },
      ],
      chartOptions: {
        chart: {
          height: 150,
          type: "area",
          toolbar: {
            show: false,
          },
          offsetY: -30,
          sparkline: {
            enabled: false,
          },
        },
        colors: ["#4CAF50"],
        stroke: {
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 3,
        },
        grid: {
          show: false,
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          labels: {
            show: false,
          },
          categories: [],
        },
        tooltip: {
          enabled: true,
          y: {
            formatter(val) {
              return `${val} aulas`;
            },
          },
        },
      },
    };
  },
  methods: {
    async getQtd(franquiaId) {
      try {
        const response = await this.$services.aulasService.graficoDeAulasDaSemana(franquiaId);

        const dataCategories = response.data.aulasDaSemana.map((d) =>
          d.data.substring(5).split("-").reverse().join("/")
        );
        this.datas = [...dataCategories];

        this.qtd = response.data.totalDeAulas;
        const dataSeries = response.data.aulasDaSemana.map((q) => q.total);

        this.series = [
          {
            name: "Aulas",
            data: [...dataSeries],
          },
        ];
      } catch (error) {
        // console.error("Erro ao carregar dados:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border-top: 4px solid #fbbb14;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.card-header {
  padding-bottom: 0;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.card-content {
  height: calc(100% - 60px);
}

.chart-container {
  padding-right: 8px;
  height: 100%;
  display: flex;
  align-items: center;
}

.text-h3 {
  line-height: 1.2;
}

.deep-purple--text {
  color: #7e57c2 !important;
}
.primary--text {
  color: #1976d2 !important;
}
</style>
